import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, FormHelperText } from '@mui/material'
import { StyledMenuItem, StyledSelect, StyledInput } from './styles'
import LabelContainer from 'components/ui-kit/LabelContainer'
import { getTranslation } from 'helpers'

const CustomSelect = ({
  label,
  error,
  onChange,
  items,
  value,
  styledvariant,
  labeltype,
  formControlStyle,
  disabled,
  helperText,
  isAllLabelNotRequired,
  ...otherProps
}) => (
  <LabelContainer type={labeltype} label={label}>
    <FormControl
      sx={
        formControlStyle || ({
          m: 1,
          ...(labeltype !== 'none'
            ? {
                minWidth: labeltype === 'filter' ? '100%' : '100%'
              }
            : {
                height: 30
              }),
          margin: 0,
          backgroundColor: (theme) => labeltype !== 'filter' ? theme.colors.white : theme.colors.lighterGrey
        })
      }
      error={error}
      size='small'
    >
      <StyledSelect
        value={value}
        onChange={onChange}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        type={labeltype}
        disabled={disabled}
        MenuProps={{
          style: {
            maxHeight: '240px'
          }
        }}
        {...otherProps}
      >

        <StyledInput placeholder='Search here..' />

        {!isAllLabelNotRequired &&
          <StyledMenuItem type={labeltype} styledvariant={styledvariant} key='default' value=''>
            {getTranslation('all')}
          </StyledMenuItem>}
        {items?.map((item) => (
          <StyledMenuItem
            type={labeltype}
            styledvariant={styledvariant}
            key={item.id || item.value}
            value={item.value}
          >
            {item.label}
          </StyledMenuItem>
        ))}
      </StyledSelect>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  </LabelContainer>
)

CustomSelect.defaultProps = {
  label: null,
  value: '',
  items: null,
  styledvariant: 'default',
  labeltype: 'default',
  formControlStyle: null,
  disabled: false,
  error: false
}

CustomSelect.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labeltype: PropTypes.oneOf(['filter', 'default', 'none']),
  styledvariant: PropTypes.oneOf(['light', 'default']),
  formControlStyle: PropTypes.object,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string
}

export default CustomSelect
